import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection,} from '@angular/core';
import {HttpClient, provideHttpClient, withInterceptorsFromDi,} from '@angular/common/http';
import {routes} from './app.routes';
import {provideRouter, withComponentInputBinding, withInMemoryScrolling,} from '@angular/router';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideClientHydration} from '@angular/platform-browser';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

// icons
import {TablerIconsModule} from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

// perfect scrollbar
import {NgScrollbarModule} from 'ngx-scrollbar';
import {NgxPermissionsModule} from 'ngx-permissions';
//Import all material modules
import {MaterialModule} from './material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material/paginator';
import {MSAL_INSTANCE, MsalModule, MsalService} from '@azure/msal-angular';
import {IPublicClientApplication, PublicClientApplication} from '@azure/msal-browser';
import {environment} from 'src/environments/environment';
import { MatPaginatorIntlService } from './utils/mat-paginator-intl.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.microsoftClientId,
      authority: environment.microsoftAuthority || 'https://login.microsoftonline.com/common',
      redirectUri: typeof window !== 'undefined' ? window.location.origin : '/',
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withComponentInputBinding()
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideClientHydration(),
    provideAnimationsAsync(),

    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      MaterialModule,
      NgxPermissionsModule.forRoot(),
      TablerIconsModule.pick(TablerIcons),
      NgScrollbarModule,
      MsalModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
    ),
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MatPaginatorIntl,
      useClass: MatPaginatorIntlService,
    },
    MsalService,
  ],
};
